if (window.$) {
  /*
   * jQuery UI Autocomplete 1.8.13
   *
   * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
   * Dual licensed under the MIT or GPL Version 2 licenses.
   * http://jquery.org/license
   *
   */
  (function($, undefined) {
    function zIndex(element, value) {
      if (typeof value !== "undefined") {
        element.css({ zIndex: value });
      }
      var result = parseInt(element.css("zIndex")) || 0;
      return result;
    }
    // used to prevent race conditions with remote data sources
    var requestIndex = 0;
    $.widget("ui.autocomplete", {
      options: {
        displayCodeOnly: false,
        appendTo: "body",
        delay: 700,
        minLength: 1,
        position: {
          my: "left-1 top",
          at: "left bottom",
          collision: "fit"
        },
        source: null,
        typeAheadSearch: true,
        openOnEnter: false,
        autoFocus: true,
        suggestHook: null //lookup behavior - just return the items and let the lookup control use its code to do it
      },
      pending: 0,
      isInGrid: false,
      _create: function() {
        var self = this,
          doc = this.element[0].ownerDocument,
          suppressKeyPress;
        this.element
          .addClass("ui-autocomplete-input")
          .attr("autocomplete", "off")
          .attr({
            role: "textbox",
            "aria-autocomplete": "list",
            "aria-haspopup": "true"
          })
          .bind("keydown.autocomplete", function(e) {
            self.handleKey(e);
          })
          .bind("keypress.autocomplete", function(e) {
            if (suppressKeyPress) {
              suppressKeyPress = false;
              e.preventDefault();
            }
          })
          .bind("focus.autocomplete", function() {
            if (self.options.disabled) {
              return;
            }
            self.selectedItem = null;
            self.previous = self.element.val();
          })
          .bind("blur.autocomplete", function(e) {
            if (self.options.disabled) {
              return;
            }
          });
        this._initSource();
        this.response = function() {
          return self._response.apply(self, arguments);
        };
        if (this.options.suggestHook == undefined) {
          //do not add menus to the page for the lookup.
          var html = "<ul></ul>";
          if (this.options.id) {
            html = "<ul id='" + this.options.id + "'></ul>";
          }
          this.menu = $(html)
            .addClass("ui-autocomplete")
            .appendTo($(this.options.appendTo || "body", doc)[0])
            // prevent the close-on-blur in case of a "slow" click on the menu (long mousedown)
            .mousedown(function(e) {
              // clicking on the scrollbar causes focus to shift to the body
              // but we can't detect a mouseup or a click immediately afterward
              // so we have to track the next mousedown and close the menu if
              // the user clicks somewhere outside of the autocomplete
              var menuElement = self.menu.element[0];
              if (!$(e.target).closest(".contextMenuItem").length) {
                setTimeout(function() {
                  $(document).one("mousedown", function(e) {
                    if (
                      e.target !== self.element[0] &&
                      e.target !== menuElement &&
                      !$.contains(menuElement, e.target)
                    ) {
                      self.close();
                    }
                  });
                }, 100);
              }
            })
            .menu({
              focus: function(e, ui) {
                var item = ui.item.data("item.autocomplete");
                if (false !== self._trigger("focus", e, { item: item })) {
                  // use value to match what will end up in the input, if it was a key e
                  if (/^key/.test(e.originalEvent.type) && item) {
                    if (self.options.displayCodeOnly) {
                      self.element.val(item.id);
                    } else {
                      self.element.val(item.value);
                    }
                  }
                }
              },
              selected: function(e, ui) {
                if (!ui.item) return;
                var item = ui.item.data("item.autocomplete"),
                  previous = self.previous;
                // only trigger when focus was lost (click on menu)
                if (self.element[0] !== doc.activeElement) {
                  self.element.focus();
                  self.previous = previous;
                  // #6109 - IE triggers two focus events and the second
                  // is asynchronous, so we need to reset the previous
                  // term synchronously and asynchronously :-(
                  setTimeout(function() {
                    self.previous = previous;
                    self.selectedItem = item;
                  }, 1);
                }
                if (
                  item &&
                  false !== self._trigger("select", e, { item: item })
                ) {
                  if (self.options.displayCodeOnly) self.element.val(item.id);
                  else {
                    var value = item.label;
                    if (value) {
                      value = value
                        .replace(/\&lt;/g, "<")
                        .replace(/\&gt;/g, ">")
                        .replace(/\&amp;/g, "&");
                      value = value
                        .replace(/<\/strong>/gi, "")
                        .replace(/<strong>/gi, "");
                    }
                    self.element.val(value);
                  }
                  self.element.attr("autocompletevalue", self.element.val());
                }
                // reset the term after the select event
                // this allows custom select handling to work properly
                self.term = self.element.val();
                self.close(e);
                self.selectedItem = item;
                //textbox value has changed, trigger change event
                self.element.trigger("change", item);
              },
              blur: function(e, ui) {
                var placeholder = self.element.attr("placeholder");
                // don't set the value of the text field if it's already correct
                // this prevents moving the cursor unnecessarily
                if (
                  self.menu.element.is(":visible") &&
                  self.element.val() !== self.term &&
                  (placeholder && placeholder !== self.term)
                ) {
                  self.element.val(self.term);
                }
              }
            })
            .css({ zIndex: zIndex(this.element) + 3000 })
            // workaround for jQuery bug #5781 http://dev.jquery.com/ticket/5781
            .css({ top: 0, left: 0 })
            .hide()
            .data("uiMenu");
        }
        if ($.fn.bgiframe) {
          this.menu.element.bgiframe();
        }
        this.isInGrid = this.element.closest(".slick-cell").length == 1;
      },
      handleKey: function(e) {
        var self = this;
        if (
          self.options.disabled ||
          (self.element.attr("readonly") &&
            !self.element.hasClass("selectOnly"))
        ) {
          return;
        }
        suppressKeyPress = false;
        var keyCode = $.ui.keyCode;
        switch (e.keyCode) {
          case keyCode.PAGE_UP:
            if (self.menu.element.is(":visible")) self._move("previousPage", e);
            break;
          case keyCode.PAGE_DOWN:
            if (self.menu.element.is(":visible")) self._move("nextPage", e);
            break;
          case keyCode.UP:
            if (self.menu == undefined) return; //in the grid
            if (!self.menu.element.is(":visible")) {
              if (!self.isInGrid) self.openList(false, e);
              return;
            }
            self._move("previous", e);
            // pre moving cursor to beginning of text field in some browsers
            e.preventDefault();
            e.stopPropagation(); //prevent moving in the grid
            break;
          case keyCode.DOWN:
            if (self.menu == undefined) return; //in the grid
            if (!self.menu.element.is(":visible")) {
              if (!self.isInGrid) self.openList(false, e);
              return;
            }
            self._move("next", e);
            // prevent moving cursor to end of text field in some browsers
            e.preventDefault();
            e.stopPropagation(); //prevent moving in the grid
            break;
          //passthrough - ENTER NUMPAD ENTER and TAB all select the current element
          case keyCode.ENTER:
          case keyCode.TAB:
          case keyCode.NUMPAD_ENTER:
            if (
              self.menu &&
              !self.menu.element.is(":visible") &&
              !self.options.openOnEnter
            )
              return;
            if ($("#lookupGridDivId").is(":visible")) {
              $("#lookupGridDivId")
                .parent()
                .hide();
              return;
            }
            self.openList(e.keyCode == keyCode.TAB, e);
            break;
          case keyCode.ESCAPE:
            self.element.val(self.term);
            self.close(e);
            break;
          default:
            // keypress is triggered before the input value is changed
            clearTimeout(self.searching);
            self.searching = setTimeout(function() {
              // only search if the value has changed
              if (
                self.term != self.element.val() &&
                self.options.typeAheadSearch
              ) {
                self.selectedItem = null;
                self.search(null, e);
              }
            }, self.options.delay);
            break;
        }
      },
      openList: function(isTab, e) {
        var self = this;
        if (self.menu == undefined) return;
        if (!self.menu.active) {
          var isOpen = self.menu.element.closest(".inforMenu").is(":visible");
          if (isOpen) self.close(e);
          else {
            if (!isTab) {
              //only open on ENTER or num_enter
              self._search("");
              e.stopPropagation();
            }
            if (!self.element.hasClass("selectOnly")) {
              //flush the typed in value when hitting enter to the select - webtop.
              var select = $(this)
                .parent()
                .prev();
              var value = this.value;
              var id = select.find(":contains('" + value + "')").val();
              select.data("selectedId", id);
              select.val(id);
              self._trigger("selected", e, {
                item: {
                  id: id,
                  label: value,
                  value: value
                }
              });
            }
          }
          return;
        }
        self.menu.select(e);
      },
      destroy: function() {
        this.element
          .removeClass("ui-autocomplete-input")
          .removeAttr("autocomplete")
          .removeAttr("role")
          .removeAttr("aria-autocomplete")
          .removeAttr("aria-haspopup");
        if (this.menu != undefined && this.menu.element != undefined)
          this.menu.element.closest(".inforMenu").remove();
        $.Widget.prototype.destroy.call(this);
      },
      makeSelectOnly: function(typeAheadSearch) {
        //Setup an editable type drop down styling and options. used in lookupfield and dropdown list
        var input = this.element,
          options = this.options,
          timeout = null,
          self = this;
        button = input.closest(".inforTriggerFieldTable").find("button");
        input
          .addClass("selectOnly")
          .data("selectOnly", true)
          .attr("readonly", "");
        if (typeAheadSearch) {
          input
            .focusin(function() {
              timeout = setTimeout(function() {
                input.select();
              }, 100);
            })
            .focusout(function() {
              clearTimeout(timeout);
            })
            .bind("keydown", function(e) {
              if (e.keyCode == 8) {
                e.stopPropagation();
                e.preventDefault();
                return false;
              }
            })
            .bind("keypress", function(e) {
              if (!typeAheadSearch) return;
              if (!input.hasClass("selectOnly")) return; //readonly...
              var charCode = e.charCode || e.keyCode,
                character = String.fromCharCode(charCode);
              if (e.ctrlKey || e.altKey)
                //allow copy paste and other keyboard commands stuff
                return;
              if ($.inArray(charCode, [34, 35, 38, 40, 8]) != -1)
                //ignore arrow up and down /page up and down and bcspace.
                return;
              if (!/^[a-zA-Z*!@#$%^&0-9]+$/i.test(character))
                //allow only alpha numerics...
                return;
              //get the key that was pressed.
              if (!e.shiftKey) character = character.toLowerCase();
              else character = character.toUpperCase();
              //trigger a search on the delay
              clearTimeout(self.searching);
              self.searching = setTimeout(function() {
                // todo : only search if the value has changed
                input.autocomplete("search", character);
              }, options.delay);
              //when the user starts typing place an input field over...
              var tempInput = $(
                "<input id='inforTempInput' autocomplete='off' class='inforTempInput'>"
              );
              //hide the current text..
              input.css("color", "white");
              input
                .parent(".inforTriggerField")
                .css("position", "relative")
                .append(tempInput);
              tempInput
                .val(character)
                .css("width", "15px")
                .putCursorAtEnd()
                .autoGrow({
                  //similute highlighted effect
                  comfortZone: 6,
                  minWidth: 16,
                  maxWidth: input.width() - 5
                })
                .bind("keydown", function(e) {
                  if (e.which === 9) {
                    input.autocomplete("handleKey", e);
                    e.stopPropagation();
                    e.preventDefault();
                  }
                  if (
                    $.inArray(e.which, [34, 35, 37, 38, 39, 40, 13, 9]) != -1
                  ) {
                    e.stopPropagation();
                    e.preventDefault();
                    return false;
                  }
                })
                .bind("keyup", function(e) {
                  input.data("holder", input.attr("placeholder"));
                  input.attr("placeholder", "");
                  //handle nav keys keys...
                  if (
                    $.inArray(e.which, [34, 35, 37, 38, 39, 40, 13, 9]) != -1
                  ) {
                    input.autocomplete("handleKey", e);
                    e.stopPropagation();
                    e.preventDefault();
                    return false;
                  } else {
                    //trigger a search on the delay
                    clearTimeout(self.searching);
                    self.searching = setTimeout(function() {
                      input.autocomplete("search", e.target.value);
                    }, options.delay);
                  }
                })
                .bind("blur", function(e) {
                  if (self.menu && self.menu.isMenuClick) {
                    return;
                  }
                  self._removeHidden(input);
                });
              e.preventDefault();
              return;
            })
            .bind("focus", function(e) {
              var $this = $(this);
              try {
                $this.select();
              } catch (err) {
                //Ignore unspecified errors in IE9
              }
            });
        } else {
          input.addClass("clickable");
          input
            .on("touchstart click", function(e) {
              if (input.prop("readonly") && !input.hasClass("selectOnly")) {
                return;
              }
              var btn = input
                .closest(".inforTriggerField")
                .find(".inforTriggerButton");
              btn.trigger("click");
              input.select();
              e.stopPropagation();
            })
            .hover(
              function(e) {
                var btn = input
                  .closest(".inforTriggerField")
                  .find(".inforTriggerButton");
                btn.addClass("ui-state-hover");
              },
              function(e) {
                var btn = input
                  .closest(".inforTriggerField")
                  .find(".inforTriggerButton");
                btn.removeClass("ui-state-hover");
              }
            );
        }
      },
      _removeHidden: function(input) {
        $("#inforTempInput").remove();
        input.css("color", "");
        input.attr("placeholder", input.data("holder"));
      },
      _setOption: function(key, value) {
        $.Widget.prototype._setOption.apply(this, arguments);
        if (key === "source") {
          this._initSource();
        }
        if (key === "appendTo") {
          this.menu.element.appendTo(
            $(value || "body", this.element[0].ownerDocument)[0]
          );
        }
        if (key === "disabled" && value && this.xhr) {
          this.xhr.abort();
        }
      },
      _initSource: function() {
        var self = this,
          array,
          url;
        if ($.isArray(this.options.source)) {
          array = this.options.source;
          this.source = function(request, response) {
            response($.ui.autocomplete.filter(array, request.term));
          };
        } else if (typeof this.options.source === "string") {
          url = this.options.source;
          this.source = function(request, response) {
            if (self.xhr) {
              self.xhr.abort();
            }
            self.xhr = $.ajax({
              url: url,
              data: request,
              dataType: "json",
              autocompleteRequest: ++requestIndex,
              success: function(data, status) {
                if (this.autocompleteRequest === requestIndex) {
                  response(data);
                }
              },
              error: function() {
                if (this.autocompleteRequest === requestIndex) {
                  response([]);
                }
              }
            });
          };
        } else {
          this.source = this.options.source;
        }
      },
      search: function(value, e) {
        value = value != null ? value : this.element.val();
        // always save the actual value, not the one passed as an argument
        this.term = this.element.val();
        if (value.length < this.options.minLength) {
          return this.close(e);
        }
        clearTimeout(this.closing);
        if (this._trigger("search", e) === false) {
          return;
        }
        return this._search(value);
      },
      _search: function(value) {
        var dataContext = null,
          column = null;
        this.pending++;
        if (this.element.closest(".inforSignInDialogControls").length == 0) {
          this.element.oldBackgroundPosition = this.element.css(
            "background-position"
          );
          this.element
            .addClass("inforBusyIndicator small")
            .css("background-position", this.element.width() - 21);
        }
        //hide the cancel on a search.
        this.element
          .closest(".inforTriggerFieldTable")
          .find(".inforTriggerSearchCancel")
          .css("opacity", 0);
        //if in a grid pass more options.
        if ($(this.element).closest(".inforDataGrid").length != 0) {
          var grid = $(this.element)
              .closest(".inforDataGrid")
              .data("gridInstance"),
            cell = grid.getActiveCell();
          if (cell) {
            dataContext = grid.getData().getItems()[cell.row];
          }
        }
        this.source({ term: value }, this.response, false, dataContext);
      },
      _response: function(content, columns, totalRows) {
        if (!this.options.disabled && content) {
          content = this._normalize(content);
          this._suggest(content, columns, totalRows);
          this._trigger("open");
        } else {
          this.close();
        }
        this.pending--;
        if (!this.pending) {
          if (this.element.closest(".inforSignInDialogControls").length == 0) {
            this.element.removeClass("inforBusyIndicator small");
            this.element.css(
              "background-position",
              this.element.oldBackgroundPosition
            );
          }
          //un hide the cancel on a search.
          this.element
            .closest(".inforTriggerFieldTable")
            .find(".inforTriggerSearchCancel")
            .css("opacity", 1);
        }
      },
      close: function(e) {
        if (this.menu == undefined) return; //return
        $(document).off("mousedown.infordropdownlist");
        this._removeHidden(this.element);
        clearTimeout(this.closing);
        var $menu = this.menu.element.closest(".inforMenu"),
          self = this;
        if (e == undefined) $menu.hide();
        if ($menu.is(":visible")) {
          $menu.slideUp("fast", function() {
            //Caused issue when tabbing to select... self.element.focus().select();
          });
          this.menu.deactivate();
          this._trigger("close", e);
        }
      },
      _change: function(e) {
        if (this.previous !== this.element.val()) {
          this._trigger("change", e, { item: this.selectedItem });
        }
      },
      _normalize: function(items) {
        // assume all items have the right format when the first item is complete
        if (items.length && items[0].label && items[0].value) {
          return items;
        }
        return $.map(items, function(item) {
          if (typeof item === "string") {
            return {
              label: item,
              value: item
            };
          }
          return $.extend(
            {
              label: item.label || item.value,
              value: item.value || item.label
            },
            item
          );
        });
      },
      _suggest: function(items, columns, totalRows) {
        //detect if this is a lookupfield. in this case show a grid..
        if (this.options.suggestHook != undefined) {
          this.options.suggestHook(items, columns, totalRows);
          return;
        }
        // don't open an empty list
        if (!items || items.length == 0) {
          return;
        }
        var $menu = this.menu.element.closest(".inforMenu"),
          self = this;
        zIndex($menu, zIndex(this.element) + 90000);
        //empty it and add new items..
        var ul = $menu.find(".popupmenu");
        ul.empty();
        this._renderMenu(ul, items);
        // Refresh should check if the active item is still in the dom, removing the need for a manual deactivate
        this.menu.deactivate();
        this.menu.refresh();
        // size and position menu
        ul.show();
        $menu.show().css("opacity", 0);
        self.menu.isMenuClick = false;
        $(document)
          .off("mousedown.infordropdownlist")
          .on("mousedown.infordropdownlist", function(e) {
            var target = $(e.target);
            if (target.is(".inforTriggerButton")) {
              return;
            }
            if ($(e.target).closest(".inforMenu").length == 0) {
              self.close();
            } else {
              self.menu.isMenuClick = true;
            }
          });
        $menu.css("height", "");
        ul.css("height", "").css("opacity", 1);
        this._resizeMenu();
        $menu.position(
          $.extend(
            {
              of: this.element
            },
            this.options.position
          )
        );
        //see if we need to adjust the positioning or size to fit on top
        var top = 0,
          trigger = this.element.closest(".inforTriggerField"),
          menuOpts = $menu.find(".popupmenu");
        top = $menu.position().top;
        var fieldPos =
            trigger.length == 0 ? this.element.offset() : trigger.offset(),
          roomOnTop = fieldPos.top,
          inputHeight = 20,
          roomOnBottom = $(document).height() - (fieldPos.top + inputHeight);
        //calc if it will fit better on top
        if (roomOnTop > roomOnBottom && roomOnTop < $menu.height()) {
          $menu.height(roomOnTop - inputHeight);
          ul.height(roomOnTop - inputHeight);
        }
        var isRTL =
          typeof Globalize != "undefined" && Globalize.culture().isRTL;
        $menu.position({
          my:
            (isRTL ? "right " : "left-1 ") +
            (roomOnTop > roomOnBottom && roomOnBottom < $menu.height()
              ? "bottom"
              : "top"),
          at:
            (isRTL ? "right " : "left ") +
            (roomOnTop > roomOnBottom && roomOnBottom < $menu.height()
              ? "top"
              : "bottom"),
          collision: "none",
          of: this.element
        });
        //position on the bottom and shrink...
        if (roomOnTop < roomOnBottom && roomOnBottom < $menu.height()) {
          $menu.height(roomOnBottom - (fieldPos.top + inputHeight + 10));
          ul.height(roomOnBottom - (fieldPos.top + inputHeight + 10));
        }
        var selectedElem = $menu.find("li.selected");
        if (this.options.autoFocus) {
          if (selectedElem.length == 0)
            this.menu.next(new $.Event("mouseover"));
        }
        $menu.css("opacity", 1).show();
        var hasImages = $menu.find(".inforDropDownImage").length > 1;
        if (hasImages) {
          $menu.css("left", parseInt($menu.css("left")) - 17 + "px");
        }
        //scroll selected element into view
        if (selectedElem.length > 0) {
          this.menu.activate(new $.Event("mouseover"), selectedElem);
        }
      },
      contentWidth: null,
      _resizeMenu: function() {
        this.menu.element.css("width", "0px");
        var width = this.menu.element[0].scrollWidth + 25;
        this.menu.element.css({
          width: width,
          "max-width": this.options.maxWidth
        });
        this.menu.element.css("border-color", "#13A3F7");
      },
      _renderMenu: function(ul, items) {
        var self = this;
        $.each(items, function(index, item) {
          self._renderItem(ul, item);
        });
      },
      _renderItem: function(ul, item) {
        var labelVal = item.label == "" ? String.fromCharCode(160) : item.label; //allow blank items
        var anchor = $("<a></a>")
          .addClass(item.cssClass)
          .html(labelVal);
        if (item.title) anchor.attr("title", item.title);
        var li = $("<li></li>")
          .data("item.autocomplete", item)
          .append(anchor)
          .appendTo(ul);
        //Match the Selected Item..
        if (this.term != "" && $.trim(this.term) == $.trim(item.label))
          li.addClass("selected");
        if (this.options.displayCodeOnly && this.term == item.id)
          li.addClass("selected");
        return li;
      },
      _move: function(direction, e) {
        if (this.menu == undefined) return;
        if (!this.menu.element.is(":visible")) {
          this.search(null, e);
          return;
        }
        if (
          (this.menu.first() && /^previous/.test(direction)) ||
          (this.menu.last() && /^next/.test(direction))
        ) {
          //this.element.val( this.term );
          //this.menu.deactivate();
          return;
        }
        this.menu[direction](e);
      },
      widget: function() {
        if (this.menu != undefined) return this.menu.element;
        else return this.element;
      }
    });
    $.extend($.ui.autocomplete, {
      escapeRegex: function(value) {
        return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      },
      filter: function(array, term) {
        var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), "i");
        return $.grep(array, function(value) {
          return matcher.test(value.label || value.value || value);
        });
      }
    });
  })(jQuery);
  /*
   * JQuery UI Menu
   *
   * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
   * Dual licensed under the MIT or GPL Version 2 licenses.
   * http://jquery.org/license
   */
  (function($) {
    $.widget("ui.menu", {
      _create: function() {
        var self = this;
        this.element
          .addClass("popupmenu is-open")
          .attr({
            role: "listbox"
          })
          .on("touchstart click", function(e) {
            if (!$(e.target).closest(".contextMenuItem a").length) {
              return;
            }
            e.preventDefault();
            e.stopPropagation(); //stop clicking in field from firing parent clicks
            self.select(e);
          });
        var id = this.element.attr("id"),
          menuDiv = $('<div class="inforMenu" role="listbox"></div>');
        if (id) {
          menuDiv.attr("id", id);
        } else {
          menuDiv.uniqueId();
        }
        $("body").append(menuDiv.append(this.element));
        this.element.css("display", "");
        this.refresh();
      },
      refresh: function() {
        var self = this;
        // don't refresh list items that are already adapted
        var items = this.element
          .children("li:not(.contextMenuItem):has(a)")
          .addClass("contextMenuItem")
          .attr("role", "option");
        items
          .children("a")
          .attr("tabindex", -1)
          // mouseenter doesn't work with event delegation
          .mouseenter(function(e) {
            self.activate(e, $(this).parent());
          })
          .mouseleave(function() {
            self.deactivate();
          });
      },
      activate: function(e, item) {
        this.deactivate();
        if (this.hasScroll()) {
          var offset = item.offset().top - this.element.offset().top,
            scroll = this.element.scrollTop(),
            elementHeight = this.element.height();
          if (offset < 0) {
            this.element.scrollTop(scroll + offset);
          } else if (offset >= elementHeight) {
            this.element.scrollTop(
              scroll + offset - elementHeight + item.height()
            );
          }
        }
        this.active = item
          .addClass("selected")
          .eq(0)
          .children("a")
          .attr("id", "ui-active-menuitem")
          .end();
        this._trigger("focus", e, { item: item });
      },
      deactivate: function() {
        if (!this.active) {
          return;
        }
        this.active
          .removeClass("selected")
          .children("a")
          .removeAttr("id");
        this._trigger("blur");
        this.active = null;
      },
      next: function(e) {
        this.move("next", ".contextMenuItem:first", e);
      },
      previous: function(e) {
        this.move("prev", ".contextMenuItem:last", e);
      },
      first: function() {
        return this.active && !this.active.prevAll(".contextMenuItem").length;
      },
      last: function() {
        return this.active && !this.active.nextAll(".contextMenuItem").length;
      },
      move: function(direction, edge, e) {
        var selected = this.element.find(".selected");
        if (!this.active && selected.length == 0) {
          this.activate(e, this.element.children(edge));
          return;
        } else {
          this.activate(e, selected);
        }
        var next = this.active[direction + "All"](".contextMenuItem").eq(0);
        if (next.length) {
          this.activate(e, next);
        } else {
          this.activate(e, this.element.children(edge));
        }
      },
      nextPage: function(e) {
        if (this.hasScroll()) {
          if (!this.active || this.last()) {
            var first = this.element.children(".contextMenuItem:first");
            this.activate(e, first);
            return;
          }
          var base = this.active.offset().top,
            height = this.element.height(),
            result = this.element
              .children(".contextMenuItem")
              .filter(function() {
                var close =
                  $(this).offset().top - base - height + $(this).height();
                return close < 10 && close > -10;
              });
          //try to catch this earlier when scrollTop indicates the last page anyway
          if (!result.length) {
            result = this.element.children(".contextMenuItem:last");
          }
          this.activate(e, result);
        } else {
          this.activate(
            e,
            this.element
              .children(".contextMenuItem")
              .filter(!this.active || this.last() ? ":first" : ":last")
          );
        }
      },
      previousPage: function(e) {
        if (this.hasScroll()) {
          //merge with no-scroll-else
          if (!this.active || this.first()) {
            this.activate(e, this.element.children(".contextMenuItem:last"));
            return;
          }
          var base = this.active.offset().top,
            height = this.element.height();
          result = this.element.children(".contextMenuItem").filter(function() {
            var close = $(this).offset().top - base + height - $(this).height();
            // TODO improve approximation
            return close < 10 && close > -10;
          });
          // try to catch this earlier when scrollTop indicates the last page anyway
          if (!result.length) {
            result = this.element.children(".contextMenuItem:first");
          }
          this.activate(e, result);
        } else {
          this.activate(
            e,
            this.element
              .children(".contextMenuItem")
              .filter(!this.active || this.first() ? ":last" : ":first")
          );
        }
      },
      hasScroll: function() {
        return (
          this.element.height() <
          this.element[$.fn.prop ? "prop" : "attr"]("scrollHeight")
        );
      },
      select: function(e) {
        this._trigger("selected", e, { item: this.active });
      }
    });
  })(jQuery);
}
